import $ from "jquery";
import { Klass } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

function addFuncHeader(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	vuw.add("funcHeader", {
		vuwType: "funcBlock",
		buttonText: {
			showlist: "一覧に戻る"
		},
		
		selector() {
			return $("<div/>").addClass("func-header")
			.appendTo(this.container.$content);
		},
		
		onReady($self) {
			!!$self && $self.on("click", ".btn-showlist", e => {
				e.preventDefault();
				vuwer.setState("v", "list");
			});
		}
	});
}

export default addFuncHeader;
